import { render, staticRenderFns } from "./AddDinningOption.vue?vue&type=template&id=6058c99e&"
import script from "./AddDinningOption.vue?vue&type=script&lang=js&"
export * from "./AddDinningOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports